export default "__VITE_ASSET__CAviUR23__"